import { render, staticRenderFns } from "./scoreRemark.vue?vue&type=template&id=23548eed&scoped=true"
import script from "./scoreRemark.vue?vue&type=script&lang=ts"
export * from "./scoreRemark.vue?vue&type=script&lang=ts"
import style0 from "./scoreRemark.vue?vue&type=style&index=0&id=23548eed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23548eed",
  null
  
)

export default component.exports